import NotificationsNoneOutlinedIcon from "@mui/icons-material/Notifications";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Badge from "@mui/material/Badge";

function NotificationsPopover({ nrNotificacoes, onClick, anchorEl }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      <Tooltip
        title={
          nrNotificacoes === 1
            ? `Tem uma notificação`
            : nrNotificacoes === 0
            ? "Não tem notificações"
            : `Tem ${nrNotificacoes} notificações`
        }
      >
        <IconButton onClick={onClick} size="large">
          <Badge badgeContent={nrNotificacoes} color="primary">
            <NotificationsNoneOutlinedIcon
              className={nrNotificacoes > 0 ? "sinoComNotificacao" : ""}
              style={{ fontSize: "28px" }}
            />
          </Badge>
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default NotificationsPopover;
